import type { DocumentCategory, RelatedRef, VaultDocument } from '@app/shared';
import { useRecords } from '../../platform/data/repo.ts';

export const CATEGORY_LABELS: Record<DocumentCategory, string> = {
  insurance: 'Insurance',
  warranty: 'Warranty',
  school: 'School',
  medical: 'Medical',
  pet: 'Pet',
  vehicle: 'Vehicle',
  home: 'Home',
  manual: 'Manual',
  receipt: 'Receipt',
  identity: 'ID & passports',
  financial: 'Financial',
  legal: 'Legal',
  other: 'Other',
};

export const CATEGORY_ICONS: Record<DocumentCategory, string> = {
  insurance: '🛡️',
  warranty: '🧾',
  school: '🎒',
  medical: '🩺',
  pet: '🐾',
  vehicle: '🚗',
  home: '🏠',
  manual: '📘',
  receipt: '🧾',
  identity: '🪪',
  financial: '💼',
  legal: '⚖️',
  other: '📄',
};

/** Collections a document can be linked to, and how to name their records. */
export const RELATABLE: { collection: string; label: string; titleField: string }[] = [
  { collection: 'pets', label: 'Pet', titleField: 'name' },
  { collection: 'assets', label: 'Home item or vehicle', titleField: 'name' },
];

export function guessCategory(name: string): DocumentCategory {
  const n = name.toLowerCase();
  if (/insur|policy/.test(n)) return 'insurance';
  if (/warrant/.test(n)) return 'warranty';
  if (/receipt|invoice/.test(n)) return 'receipt';
  if (/manual|guide/.test(n)) return 'manual';
  if (/school|report card|class/.test(n)) return 'school';
  if (/vet|vaccin|rabies/.test(n)) return 'pet';
  if (/passport|license|birth cert/.test(n)) return 'identity';
  if (/car|vehicle|registration|title/.test(n)) return 'vehicle';
  return 'other';
}

export function useDocuments(): VaultDocument[] | undefined {
  return useRecords<VaultDocument>('documents');
}

export function useRelatedDocuments(ref: RelatedRef): VaultDocument[] {
  const docs = useDocuments() ?? [];
  return docs.filter((d) => d.related.some((r) => r.collection === ref.collection && r.id === ref.id));
}
